export const GET_NEW_BUSINESSES = 'NEW_BUSINESSES/get_new_businesses';
export const GET_SINGLE_NEW_BUSINESSES =
  'NEW_BUSINESSES/get_single_new_businesses';
export const UPDATE_NEW_BUSINESSES = 'NEW_BUSINESSES/update_new_businesses';
export const CREATE_NEW_BUSINESSES = 'NEW_BUSINESSES/create_new_businesses';
export const REMOVE_NEW_BUSINESSES = 'NEW_BUSINESSES/remove_new_businesses';
export const REMOVE_BUSINESS_APPLICATION =
  'NEW_BUSINESSES/remove_business_application';
export const REMOVE_USER = 'NEW_BUSINESSES/remove_user';

export const GET_NEW_BUSINESS_ACTIVITIES =
  'NEW_BUSINESS_ACTIVITIES/get_new_business_activities';
export const UPDATE_NEW_BUSINESS_ACTIVITIES =
  'NEW_BUSINESS_ACTIVITIES/update_new_business_activities';
export const CREATE_NEW_BUSINESS_ACTIVITIES =
  'NEW_BUSINESS_ACTIVITIES/create_new_business_activities';
export const REMOVE_NEW_BUSINESS_ACTIVITIES =
  'NEW_BUSINESS_ACTIVITIES/remove_new_business_activities';

export const GET_NEW_BUSINESS_NATURE_ID =
  'NEW_BUSINESS_ACTIVITIES/get_new_business_nature_id';
export const GET_NEW_BUSINESS_LINE_ID =
  'NEW_BUSINESS_ACTIVITIES/get_new_business_line_id';

export const GET_NECESSARY_FIELD_LIST =
  'NEW_BUSINESS_ACTIVITIES/get_necessary_field_list';

export const TOGGLE_ACTIVITY_RETIREMENT = `TOGGLE_ACTIVITY_RETIREMENT/toggle_activity_retirement`;

export const TOGGLE_BUSINESS_RETIREMENT = `TOGGLE_BUSINESS_RETIREMENT/toggle_business_retirement`;

export const GET_TAXPAYER_LIST = 'NEW_BUSINESSES/get_taxpayers_list';
export const HOLD_BUSINESS = 'NEW_BUSINESSES/hold_business';
export const GET_VETERINARY_FEE_LIST = 'NEW_BUSINESSES/get_veterinary_fee_list';
export const UPDATE_BUSINESS_ASSIGN = 'NEW_BUSINESSES/update_business_assign';
export const GET_BUSINESS_AUDIT_LOGS = 'NEW_BUSINESSES/get_business_audit_logs';
export const ADD_TAX_CREDIT = 'BUSINESS/add_tax_credit';
export const UPDATE_TAX_CREDIT = 'BUSINESS/update_tax_credit';
export const UPDATE_VETERINARY_FEE = 'BUSINESS/update_veterinary_fee';
export const GET_BUSINESS_NECESSARY_FIELD =
  'BUSINESS/get_business_necessary_field';
export const GET_BUSINESS_LINES_LIST = 'BUSINESS/get_business_lines_list';
export const GET_FEES_LIST = 'BUSINESS/get_fees_list';
export const DELETE_APPLICATION_FEES = 'BUSINESS/delete_application_fees';
export const REVOKE_PERMIT = 'BUSINESS/revoke_permit';
export const REVOKE_PERMIT_BARANGAY_CLEARANCE =
  'BUSINESS/revoke_permit_barangay_clearance';
export const VALIDATE = `BUSINESS/validate`;
export const DEDUCT_TAX_CREDIT = `BUSINESS/deduct_tax_credit`;

export const FORM_DATA = {
  name: '',
  kind_of_ownership: '',
  bin: '',
  tin_no: '',
  dti_no: '',
  sec_no: '',
  cellphone_no: '',
  telephone_no: '',
  area_of_business_establishment: '',
  no_of_employees: '',
  taxpayer_id: '',
  region_code: '130000000',
  province_code: '133900000',
  municipality_code: '',
  barangay_code: '',
  street: '',
};

export const BUSINESS_ACTIVITIES_FORM_DATA = {
  business_nature_id: '',
  business_line_id: '',
  capital_amount: '',
  gross_amount: '',
};

export const KIND_OF_OWNERSHIP = [
  // { label: 'ALL', value: '' },
  { label: 'COOPERATIVE', value: 'COOPERATIVE' },
  { label: 'CORPORATION', value: 'CORPORATION' },
  { label: 'ONE PERSON CORPORATION', value: 'ONE PERSON CORPORATION' },
  { label: 'PARTNERSHIP', value: 'PARTNERSHIP' },
  { label: 'SOLE PROPRIETORSHIP', value: 'SOLE PROPRIETORSHIP' },
];

export const BUSINESS_STATUS = [
  { label: 'ACTIVE', value: 'ACTIVE' },
  { label: 'INACTIVE', value: 'INACTIVE' },
  { label: 'REVOKED', value: 'REVOKED' },
  { label: 'RETIRED', value: 'RETIRED' },
];

export const BUSINESS_DESCRIPTION = [
  { label: 'FULLY PAID', value: 'FULLY PAID' },
  { label: 'WITH BALANCE', value: 'WITH BALANCE' },
  { label: 'WITH OVERDUE BALANCE', value: 'WITH OVERDUE BALANCE' },
  { label: 'PERMIT EXPIRED', value: 'PERMIT EXPIRED' },
  { label: 'PERMIT EXPIRED WITH OVERDUE BALANCE', value: 'PERMIT EXPIRED WITH OVERDUE BALANCE' },
  { label: 'PERMIT REVOKED', value: 'PERMIT REVOKED' },
  { label: 'BUSINESS RETIRED', value: 'BUSINESS RETIRED' },
];

export const BUSINESS_DESCRIPTION_BY_STATUS = {
  ACTIVE: [
    { label: 'FULLY PAID', value: 'FULLY PAID' },
    { label: 'WITH BALANCE', value: 'WITH BALANCE' },
    { label: 'WITH OVERDUE BALANCE', value: 'WITH OVERDUE BALANCE' },
  ],
  INACTIVE: [
    { label: 'PERMIT EXPIRED', value: 'PERMIT EXPIRED' },
    {
      label: 'PERMIT EXPIRED WITH OVERDUE BALANCE',
      value: 'PERMIT EXPIRED WITH OVERDUE BALANCE',
    },
  ],
  REVOKED: [{ label: 'PERMIT REVOKED', value: 'PERMIT REVOKED' }],
  RETIRED: [{ label: 'BUSINESS RETIRED', value: 'BUSINESS RETIRED' }],
};

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR', value: 'JR' },
  { label: 'SR', value: 'SR' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
  { label: 'XI', value: 'XI' },
  { label: 'XII', value: 'XII' },
  { label: 'XIII', value: 'XIII' },
  { label: 'XIV', value: 'XIV' },
  { label: 'XV', value: 'XV' },
  { label: 'XVI', value: 'XVI' },
  { label: 'XVII', value: 'XVII' },
  { label: 'XVIII', value: 'XVIII' },
  { label: 'XIX', value: 'XIX' },
  { label: 'XX', value: 'XX' },
];

export const OWNERS_GENDER = [
  { label: 'MALE', value: 'M' },
  { label: 'FEMALE', value: 'F' },
];
